import axios from './axios';

export const getCSVFile = async (token) => {
  try {
    const response = await axios.get('/download-csv', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getUsersCSVFile = async (token) => {
  try {
    const response = await axios.get('/download-users-csv', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFirmwareFile = async (file) => {
  try {
    const response = await axios.get(file);
    return response;
  } catch (error) {
    return error.response;
  }
};
